import { computed, type ComputedRef } from 'vue';
import type { HydratedBlock } from '@pleased-npm/fe-customisation';
import { useGetPage } from './useGetPage';
import { findBlockByKey } from '../utils/document.utils';
import { composableTracker } from '../utils/composableTracker';

export interface GetPageBlockParams {
  registryId: string;
  blockKey: string;
}

/**
 * Get a block from a page document.
 * @param params - Object containing registryId and blockKey
 * @returns ComputedRef of HydratedBlock with theme values applied, or null if page not loaded or block not found
 */
export const useGetPageBlock = ({ registryId, blockKey }: GetPageBlockParams): ComputedRef<HydratedBlock | null> => {
  const trackKey = `${registryId}/${blockKey}`;
  composableTracker.track('useGetPageBlock', 'call', trackKey);

  const page = useGetPage({ registryId });

  return computed(() => {
    composableTracker.track('useGetPageBlock', 'computedEvaluated', trackKey);

    if (!page.value) {
      return null;
    }

    try {
      return findBlockByKey(page.value, blockKey) as HydratedBlock;
    } catch {
      return null;
    }
  });
};
